export default __webpack_public_path__ + "media/images/svg/dog-decor-3-7f7f85fc21e3d5c05b830d68b42dfb4b.svg";